import Table from '../../../../utils/ResultViewer/Table'
import React, { useState } from 'react'
const JsonModal: React.FC<{ visible: boolean; onClose: () => void; json: string | null }> = ({
  visible,
  onClose,
  json,
}) => {
  if (!visible) return null

  return (
    <div
      style={{
        position: 'fixed',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.4)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      <div
        style={{
          background: '#fff',
          padding: 20,
          maxWidth: '90%',
          maxHeight: '80%',
          overflow: 'auto',
          borderRadius: 6,
        }}
      >
        <div
          style={{
            marginBottom: 12,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <strong>Additional Info</strong>
          <button onClick={onClose} className='btn btn-sm btn-light'>
            <span className='fa fa-close'></span>
          </button>
        </div>
        <pre
          className='bg-light rounded p-3 mb-0'
          style={{
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            fontSize: 12,
            maxHeight: '100px',
            overflow: 'auto',
            maxWidth: '500px',
          }}
        >
          <code>{json ?? 'null'}</code>
        </pre>
      </div>
    </div>
  )
}

class DataFilesTable extends Table {
  renderRow(row: any, key: string, colIndex: number): JSX.Element {
    if (key === 'addtional_info') {
      const fullData = row[key]

      if (fullData == null) {
        return <td key={colIndex}>-</td>
      }

      const jsonString = typeof fullData === 'string' ? fullData : JSON.stringify(fullData, null, 2)

      const MAX_LEN = 20
      const displayData =
        jsonString.length > MAX_LEN ? jsonString.substring(0, MAX_LEN) + '...' : jsonString
      const Wrapper: React.FC = () => {
        const [visible, setVisible] = useState(false)
        return (
          <>
            <td
              key={colIndex}
              title={jsonString}
              style={{ cursor: jsonString.length > MAX_LEN ? 'pointer' : 'default' }}
              onClick={() => {
                if (jsonString.length > MAX_LEN) setVisible(true)
              }}
            >
              {displayData}
            </td>
            <JsonModal visible={visible} onClose={() => setVisible(false)} json={jsonString} />
          </>
        )
      }

      return (<Wrapper />) as unknown as JSX.Element
    }
    return super.renderRow(row, key, colIndex)
  }
}

export default DataFilesTable
